import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { initSentry } from './services/sentry';
import './styles/global.css';

// Initialize Sentry before rendering
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>{error instanceof Error ? error.message : 'An unexpected error occurred'}</p>
          <button onClick={resetError} style={{ marginTop: '1rem' }}>
            Try again
          </button>
        </div>
      )}
      onError={(error, componentStack) => {
        console.error('React Error Boundary caught an error:', error);
        console.error('Component stack:', componentStack);
      }}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
